import {
    getWacInfoQueueShift,
    onFinishGetWacInfoOperation,
    onStartGetWacInfoOperation,
    processGetWacInfoQueue,
} from '../actions/internalActions';
import store from '../store/store';
import { maxActiveGetWacInfoOperation } from '../utils/constants';
import forceGetWacInfoOperation from '../utils/forceGetWacInfoOperation';
import { orchestrator } from 'satcheljs';

orchestrator(processGetWacInfoQueue, async () => {
    if (!store.getWacInfoQueue.length) {
        return;
    }

    if (store.activeGetWacInfoOperations.length >= maxActiveGetWacInfoOperation) {
        return;
    }

    const url = store.getWacInfoQueue[0];
    onStartGetWacInfoOperation(url);
    getWacInfoQueueShift();

    try {
        await forceGetWacInfoOperation(url, false /* shouldReturnDocLinkPreviewInfo */);
    } finally {
        onFinishGetWacInfoOperation(url);
        processGetWacInfoQueue();
    }
});
